import React from 'react'
import Link from 'gatsby-link'
import Tutorial from "../components/Tutorial";

const ThirdPage = () => (
    <div>
        <Tutorial />
    </div>
)

export default ThirdPage


// WEBPACK FOOTER //
// ./src/pages/tutorial.js